module.exports = __webpack_public_path__ + "static/media/480.9fbe50fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-tree-planting/light/480.png
// module id = 2514
// module chunks = 2